export default __webpack_public_path__ + "e31bc752131ad348af90a6caaaec7418.svg";